module.exports = __webpack_public_path__ + "static/ga-logo-f6360a973f47b2a95db240ab4798c234.svg";